export const OBJECT_COMPENSATION = {
    WAIT: 1,
    SUCCESS: 2,
    PENDING_APPROVAL: 3,
    REJECT_APPROVAL: 4,
    WAIT_SIGN: 5,
  };

  export const OBJECT_LABEL_EXTEND = [
    { value: 1, label: "1 năm" },
    { value: 2, label: "2 năm" },
    { value: 3, label: "3 năm" },
  ];